import { useState } from "react";
import { useNavigate } from "@tanstack/react-router";

import Navbar from "@/components/Common/Navbar";
import AdminBreadcrumb from "@/features/admin/components/AdminBreadcrumb";
import RegisterForm from "@/features/manager/components/AddNewUser/RegisterForm";

export default function AddNewUserContainer() {
  const [isSuccess, setIsSuccess] = useState(false);
  const navigate = useNavigate();

  const handleSuccess = () => {
    setIsSuccess(true);
    // Redirect to team management page after a short delay to show success state
    setTimeout(() => {
      navigate({ to: "/manager/subscription-management" });
    }, 1500);
  };

  return (
    <main className="scrollbar-thin flex h-screen min-h-0 flex-1 flex-col gap-7 overflow-y-auto p-3 px-4 pr-0 pl-6 transition-all duration-300">
      <div className="mb-5 flex-shrink-0">
        <Navbar subtitle="manager" />
      </div>

      <div className="flex-shrink-0 px-4 transition-all duration-300 md:px-16 lg:px-[120px]">
        <AdminBreadcrumb title={`Add new hash key`} />
      </div>

      <div className="min-h-0 flex-1 px-4 transition-all duration-300 md:px-16 lg:px-[120px]">
        <div className="flex min-h-0 w-full flex-row justify-start gap-8 pb-20">
          <div className="m-auto w-full max-w-[600px] gap-3">
            {isSuccess && (
              <div className="mb-6 rounded-lg bg-green-50 p-4">
                <p className="font-medium text-green-800">
                  User has been successfully created! Redirecting to team
                  management...
                </p>
              </div>
            )}

            <RegisterForm onSuccess={handleSuccess} />
          </div>
        </div>
      </div>
    </main>
  );
}
